import type { TagDesignTokens, TagTokenSections } from '@primeuix/themes/types/tag';

// Brand guide Tag (O15): 14px, weight 600, radius-small (4px), `neutral-darkest-5`
// ground, `neutral-darkest` text. `[rounded]="true"` gives the guide's `pill`
// (radius-full; secondary severity = neutral-lightest + wine + neutral-lighter
// border, see cleverly-overrides.scss). No orange tags: orange belongs to the CTA.
// Status severities use the feedback roles (O3).
export const root: TagTokenSections.Root = {
    fontSize: '0.875rem',
    fontWeight: '600',
    padding: '4px 8px',
    gap: '6px',
    borderRadius: '{borderRadius.xs}',
    roundedBorderRadius: '{extend.borderRadius.rounded}'
};

export const icon: TagTokenSections.Icon = {
    size: '0.75rem'
};

export const colorScheme: TagTokenSections.ColorScheme = {
    light: {
        primary: {
            background: '{extend.surfacesubtle}',
            color: '{extend.textneutral}'
        },
        secondary: {
            background: '{extend.surfacepage}',
            color: '{extend.textheading}'
        },
        success: {
            background: '{extend.statesuccessbg}',
            color: '{extend.statesuccess}'
        },
        info: {
            background: '{extend.stateinfobg}',
            color: '{extend.stateinfo}'
        },
        warn: {
            background: '{extend.statewarningbg}',
            color: '{extend.statewarning}'
        },
        danger: {
            background: '{extend.stateerrorbg}',
            color: '{extend.stateerror}'
        },
        contrast: {
            background: '{sand.950}',
            color: '{surface.0}'
        }
    },
    dark: {
        primary: {
            background: 'color-mix(in srgb, {primary.500} 18%, transparent)',
            color: '{primary.200}'
        },
        secondary: {
            background: '{surface.800}',
            color: '{surface.300}'
        },
        success: {
            background: 'rgba(46, 139, 87, 0.22)',
            color: '{green.300}'
        },
        info: {
            background: 'rgba(43, 127, 209, 0.22)',
            color: '{blue.300}'
        },
        warn: {
            background: 'rgba(255, 210, 74, 0.22)',
            color: '{yellow.300}'
        },
        danger: {
            background: 'rgba(194, 142, 157, 0.22)',
            color: '{wine.300}'
        },
        contrast: {
            background: '{surface.0}',
            color: '{surface.950}'
        }
    }
};

export default {
    root,
    icon,
    colorScheme
} satisfies TagDesignTokens;
